export default {
  env: 'production',
  version: "1.7.12",
  api: {
    base_url: 'https://us-central1-totemic-bonus-239316.cloudfunctions.net/api/',
    automation_url: 'https://automation.usabg.com'
  },
  integrations: {
    google_tag_manager: {
      tag: 'GTM-W3M2CQ7K',
    },
    google_analytics: {
      tag: 'G-STKT5NDS2X'
    },
    stripe: {
      key: 'pk_live_51J0X48CB1dfLO0v7Cqu6zoHMWEBfTIuHqxph9gPXiEpIm3JpfdKBvO5NyFHHQVga7J7292OCo2qEfiNQOsIgtYil00K0i3rmpa'
    },
    track_js: {
      token: '6d9aba7876784482b2ddd727803a0b1f',
      application: 'ww0geqrvjird0rt4hjs3gkdh9',
      console: { display: false },
    },
    firebase: {
      config: {
        apiKey: 'AIzaSyAz_70O4sDQ9Vc7cmVDdJ-WikgC7R1Uvaw',
        authDomain: 'totemic-bonus-239316.firebaseapp.com',
        projectId: 'totemic-bonus-239316',
        storageBucket: 'totemic-bonus-239316.appspot.com',
        messagingSenderId: '1013363213877',
        appId: '1:1013363213877:web:800ad5b331e9451d67137c',
	vapidKey: ''
      },
      appCheck: {
        recaptchaSiteKey: '6LdgUzQtAAAAAPUNNY8wMWQeD1cJX2HgKYJSY24L',
        debugToken: '',
      }
    },
    adobe_sign: {
      client_id: 'CBJCHBCAABAAT5hSWPjrVaMSDlB78FLxzsM24XEvT0s5',
    },
    bm10x: {
      enable: true,
      client_id: '6669b4a4d4d6f250df6264a2-m8q6wbaf',
      redirect_url: `https://automation.usabg.com/nova-vendor/bm10x-dashboard/bm10x/oauth/location`
    },
    google_recaptcha: {
			key: "6Le1iY0sAAAAAM9JC0Cr9CCTwitwfSEDFLNyFj1a"
    }
  },
}
